module.exports = __webpack_public_path__ + "static/media/Dislike.d46615b5.svg";